import { AnalyticsDateRange } from "../models/AnalyticsDateRange";
import { AnalyticsResults } from "../models/AnalyticsResults";
import { ResponseModel } from "../models/shared/ResponseModel";
import { UPGRADE_LINK } from "./shared/constants";

export const calculateResults = (allItems: ResponseModel[], dateRange: AnalyticsDateRange): AnalyticsResults => {

    let prevItems: ResponseModel[] = [];
    let items: ResponseModel[] = [];
    let npsSum = 0;
    let prevNpsSum = 0;

    for (const item of allItems) {
        if (item.createdAt < dateRange.from) {
            prevNpsSum += item.nps;
            prevItems.push(item);
        } else {
            npsSum += item.nps;
            items.push(item);
        }
    }

    return {
        items,
        prevItems,

        nps: round(npsSum / items.length),
        prevNps: round(prevNpsSum / prevItems.length),
    }
}


export const round = (value: number) => {
    if (!value) {
        return 0;
    }

    return Math.round(value * 100) / 100;
}

export const redirectToUpgrade = (instanceId: string) => {
    window.location.href = UPGRADE_LINK + instanceId;
}